import { render, staticRenderFns } from "./OpenStudentLesson.vue?vue&type=template&id=13f3ed7e&"
import script from "./OpenStudentLesson.vue?vue&type=script&lang=js&"
export * from "./OpenStudentLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports